import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScAdvantages = styled.ul`
  margin-top: 0;
  width: 100%;
  display: grid;
  list-style: none;
  z-index: 2;
  gap: 16px;
  grid-template-columns: repeat(3, 1fr);
  padding-inline: 24px;
  @media (${device.mobile}) {
    gap: 12px;
    grid-template-columns: 1fr;
    width: 228px;
    padding-inline: 0;
  }
`;

export const ScAdvantageItem = styled.li<{ isOffer: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  white-space: ${({ isOffer }) => (isOffer ? 'nowrap' : 'normal')};
  @media (${device.mobile}) {
    font-size: 16px;
    line-height: 20px;
  }

  .icon {
    background-color: ${({ theme }) => theme.whiteColor};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 8px;
    width: 32px;
    height: 32px;
    @media (${device.mobile}) {
      width: 48px;
      height: 48px;
      margin-right: 12px;
    }

    img {
      width: 18px;
      height: 18px;
      object-fit: contain;
      @media (${device.mobile}) {
        width: 28px;
        height: 28px;
      }
    }
  }

  @media (${device.mobile}) {
    white-space: normal;

    .label {
      &.fr-ca,
      &.fr-ch,
      &.de {
        font-size: 12px;
      }
    }
  }
`;
